export const baseUrl = "https://ganzrund.com";
export const blogUrl = "/aktuelles";
